<template>
  <div :class="{ invisible: !showTable }">
    <div class="header">
      <h2>Art Requests</h2>
    </div>
    <BBDataTable
      ref="artRequestTable"
      class="artRequest"
      :columns="columns"
      :support-add-new="false"
      path-url-api="designs"
      :load-items-fn="onItemsLoaded"
      :default-api-params="{
        _fields:
          'statuses,createdAt,note,currentStatus.name,currentStatus.status,artRequest',
        _sort: 'createdAt',
        _order: 'desc',
        _fieldsNoPopulate: 'name,_id',
        _filter: [
          {
            field: 'isDeleted',
            op: '=',
            val: 'false'
          },
          {
            field: 'artRequest.reviewByUser',
            op: '!=',
            val: 'true'
          },
          {
            field: 'user',
            op: '=',
            val: userId
          },
          {
            field: 'currentStatus',
            op: '=',
            op: 'in',
            val: [
              this.designStatusArtApproved,
              this.designStatusArtReturned,
              this.designStatusArtPendingMod,
              this.designStatusArtCompleteMod,
              this.designStatusArtRequest
            ]
          }
        ]
      }"
    >
      <template v-slot:customCell="{ props }">
        <div class="limitNote" v-if="props.column.field == 'note'">
          {{ getNoteDesign(props.row) }}
        </div>
        <div v-if="props.column.field == 'attachments'" class="fileWidth">
          <span v-for="file in getAttachmentsDesign(props.row)" :key="file._id">
            <font-awesome-icon
              :id="file._id"
              class="mr-2 fileIcon"
              :icon="icons.file"
              @click="onOpeningUploadedAttachment(file.link)"
            />
            <b-tooltip :target="file._id" triggers="hover" placement="right">
              {{ file.filename }}
            </b-tooltip>
          </span>
        </div>
        <div
          v-else-if="props.column.field == 'currentStatus'"
          class="currentStatusCell "
        >
          <div
            class="statusCell"
            v-if="[2, 4, 5].includes(props.row.currentStatus.status)"
          >
            In Progress
          </div>
          <div
            class="statusCell blueGround"
            v-else-if="[3, 6].includes(props.row.currentStatus.status)"
          >
            Please Review
          </div>
        </div>
      </template>
      <template v-slot:customButtons="slotProps">
        <div
          @click="redirectReview(slotProps.props.row)"
          class="btn btn-link btn-highlight btn-sm d-flex align-items-center ml-1"
          v-if="slotProps.props.row"
        >
          <font-awesome-icon class="mr-2" :icon="icons.eyeIcon" />
          <span class="bb-label">REVIEW</span>
        </div>
      </template>
    </BBDataTable>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { faEye, faFile, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import designService from '@/services/DesignService'
import { namespace } from 'vuex-class'

const oauthStore = namespace('oauthStore')
const designStore = namespace('designStore')
@Component({
  components: {}
})
export default class ArtRequest extends Vue {
  @designStore.Action('patchItem') patchDesign
  @oauthStore.Getter('userId') userId

  icons = {
    eyeIcon: faEye,
    file: faFile,
    trash: faTrashAlt
  }

  showTable = false

  onItemsLoaded(rows) {
    if (rows.length > 0) this.showTable = true

    return { rows: rows }
  }

  mounted() {
    this.$root.$on('reloadArtRequestTable', () => {
      this.$refs.artRequestTable.loadItems()
    })
  }

  redirectReview(design) {
    let promise = Promise.resolve(true)

    if ([3, 6].includes(design.currentStatus.status)) {
      let artRequest = design.artRequest || {}
      artRequest.reviewByUser = true
      promise = this.patchDesign({ _id: design.id, artRequest: artRequest })
    }

    promise.then(() => {
      this.$router.push({
        name: 'designPreview',
        params: {
          id: design._id
        }
      })
    })
  }

  getNoteDesign(design) {
    if (design && design.statuses) {
      if ([3, 6].includes(design.currentStatus.status)) {
        return design.note.note
      } else {
        let allowStatuses = design.statuses.filter(x =>
          x.status.includes(
            this.designStatusArtRequest,
            this.designStatusArtApproved,
            this.designStatusArtReturned
          )
        )

        let lastStatus = allowStatuses.pop()
        return (lastStatus && lastStatus.note) || ''
      }
    }
    return ''
  }

  getAttachmentsDesign(design) {
    if (design && design.statuses) {
      if ([3, 6].includes(design.currentStatus.status)) {
        return design.note.attachmentsNote
      } else {
        let allowStatuses = design.statuses.filter(x =>
          x.status.includes(
            this.designStatusArtRequest,
            this.designStatusArtApproved,
            this.designStatusArtReturned
          )
        )

        let lastStatus = allowStatuses.pop()
        return (lastStatus && lastStatus.attachmentsNote) || []
      }
    }
    return []
  }

  onOpeningUploadedAttachment(fileLink) {
    window.open(fileLink, '_blank')
  }

  get columns() {
    return [
      {
        label: 'ID',
        field: '_id',
        hidden: true
      },
      {
        label: 'Design Name',
        field: 'name',
        tdClass: 'boldText adjustCell'
      },
      {
        label: 'Notes',
        field: 'note',
        type: 'customCell'
      },
      {
        label: 'Attachments',
        field: 'attachments',
        type: 'customCell'
      },
      {
        label: 'Created On',
        field: 'createdAt',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DDTHH:mm:ss.SSS', // expects 2018-03-16T05:29:18.123
        dateOutputFormat: 'MM/DD/YYYY',
        tdClass: 'bBkgund'
      },
      {
        label: 'Status',
        field: 'currentStatus',
        type: 'customCell'
      },
      {
        label: 'Actions',
        field: 'actions'
      }
    ]
  }

  imgSubmission = {
    center: true,
    blank: true,
    blankColor: '#bbb',
    height: 50
  }
}
</script>

<style lang="scss" scoped>
.artRequest {
  /deep/ {
    table.vgt-table tbody tr td {
      vertical-align: middle;
    }
  }
}
.fileIcon {
  cursor: pointer;
}
.fileWidth {
  max-width: 130px;
}
.invisible {
  display: none;
}
.limitNote {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
}
/deep/ {
  > div table.vgt-table tbody tr.bb-data-table-row td.bBkgund {
    height: 50px;
    padding: 0;
    div {
      height: 100%;

      .statusCell {
        &.blueGround {
          background-color: #b4e1fc;
        }
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
      }
    }
  }
}
</style>
